var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcongotoSettings = function SvgIcongotoSettings(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Dashboard/icon.goto_settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dashboard/icon.goto_settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,12.5 L16.2781746,12.5 M12.0355339,17.4497475 L16.9852814,12.5 M12.0355339,7.55025253 L16.9852814,12.5",
    id: "Combined-Shape",
    stroke: "#09BE86",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,6.01923082 L5,3 C5,1.8954305 5.81015141,1 6.80952381,1 L22.1904762,1 C23.1898486,1 24,1.8954305 24,3 L24,22 C24,23.1045695 23.1898486,24 22.1904762,24 L6.80952381,24 C5.81015141,24 5,23.1045695 5,22 L5,18.9974695 L5,18.9974695",
    id: "Path",
    stroke: "#09BE86",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcongotoSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.goto_settings.a1eecac932b66ba7f2a1154cc0a70fc5.svg";